<template>
    <div class="accommodation">
  
      <div class="title-button">
  
        <h1>Currency Exchange rates</h1>
  
        <router-link to="/currency-exchange/create" class="button p-3" v-if="userRole == 1">New Exchange Rate</router-link>
  
      </div>
  
      <div class="box">
  
        <form @submit.stop.prevent="doSearch" class="box__header form--inline">
          <input v-model="quickSearch" type="search" placeholder="Quick search">
          <button class="button button--small" type="submit">Search</button>
        </form>
  
        <vdtnet-table
          ref="table"
          :fields="fields"
          :opts="options"
          @edit="doAlertEdit"
          @delete="doAlertDelete"
          >
        </vdtnet-table>
  
      </div><!-- box -->
  
    </div>
  </template>
  
  <script>
  import 'datatables.net'
  import 'datatables.net-select'
  import VdtnetTable from 'vue-datatables-net'
  
  export default {
    name: 'ExchangeIndex',
    components: {
      VdtnetTable
    },
    computed: {
      userRole() {
        return localStorage.getItem("user_role");
      },
    },
    data() {
      return {
        options: {
          ajax: {
            url: this.$api + 'currency-exchange/get-table',
            'headers': {
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
            }
          },
          responsive: false,
          processing: true,
          searching: true,
          searchDelay: 1500,
          destroy: true,
          ordering: true,
          lengthChange: true,
          serverSide: true,
          dom: 'rtlip',
          autoWidth: false,
          lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
          pageLength: 25,
        },
        fields: {
          name: { label: 'Name'},
          short_name: { label: 'Short Name'},
          symbol: { label: 'Symbol'},
          start_date: { 
            label: 'Start Date',
            render: (data, type, row) => {
              return `${ this.$options.filters.formatDate(data)}`  
            }
          },
          end_date: { 
            label: 'End Date',
            render: (data, type, row) => {
              return `${ this.$options.filters.formatDate(data)}` 
            }
          },
          exchange_rate: { label: 'Exchange Rate'},
          currency_id: {
            sortable: false,
            label: ' ',
            render: (data, type, row) => {
              if (this.userRole == 1) {
                return `<a href="/currency-exchange/edit/${row.currency_id}" data-action="edit" class="icon icon--more">Edit</a>`
              } else {
                return ''
              }
            }
          },
          slug: {
            sortable: false,
            label: ' ',
            className: 'table-action',
            render: (data, type, row) => {
              if (this.userRole == 1) {
                return `<a href="/currency-exchange/${ row.currency_id }/delete" data-action="delete" class="icon icon--delete">Delete</a>`
              } else {
                return ''
              }
                
            }
          }
        },
        quickSearch: ''
      }
    },
    methods: {
      doSearch() {
        this.$refs.table.search(this.quickSearch)
      },
      doAlertEdit(data) {
        this.$router.push({ name: 'edit-currency-exchange', params: { id: data.currency_id }})
      },
      doAlertDelete(data) {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'currency-exchange/' + data.currency_id + '/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if(response.status) {
            this.$refs.table.reload()
            this.$notify({
              type: 'success',
              title: response.message
            });
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            });
          } else {
            this.$notify({
              type: 'error',
              title: response.Error
            });
          }
          this.$store.dispatch('setLoadStatus')
        });
      },
    }
  }
  
  </script>
  